import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { IBenchConsultant } from "../../models/BenchConsultant";
import { Fetch } from "../../shared/Fetch";
import { EmptyBenchConsultant } from "./EmptyBenchConsultant";
import { IModel } from "./BenchConsultant";
import { Filter } from "./Filter";
import { ILogin, IPermissionProps } from "../../models/Login";
import { SalesManagerList } from "./SalesManagerList";
import { Accordion, AccordionTab } from "primereact/accordion";
import { HotList } from "./HotList";
import { format } from "date-fns";
import { Status } from "./Status";
import { Interview } from "./Interview";
import { Submission } from "./Submission";
import { BenchSubmissionList } from "./SubmissionList";
import { BenchECIList } from "./ECIList";
import { safeFormatDate } from "../../models/DateFormatMapper";

interface Iprops {
    setModal: (modal: IModel) => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    permissions: IPermissionProps
}

export const Table = (props: Iprops) => {

    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IBenchConsultant>, loading: boolean });
    const [filters, setFilters] = useState<string | null>(null);
    const [selectedBenchs, setSelectedBenchs] = useState<IBenchConsultant[] | null>(null);
    const dt = useRef<any>(null);

    const [openHotList, setOpenHotList] = useState(false);
    const [selectedHotList, setSelectedHotList] = useState<Array<number | undefined>>();
    const hideDialog = () => { setOpenHotList(false); setSelectedHotList([]); }
    useEffect(() => {
        loadTableData();
    }, [filters, props.reload]);

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const [slist, setSlist] = useState({ open: false, singleData: {} } as { open: boolean, singleData: IBenchConsultant });
    const hideSlistDialog = () => { setSlist({ open: false, singleData: {} }) };
    const [status, setStatus] = useState({ open: false, singleData: {} } as { open: boolean, singleData: IBenchConsultant });
    const hideStatusDialog = () => { setStatus({ open: false, singleData: {} }) };
    const [interviewForm, setInterviewForm] = useState(false);
    const hideInterviewFormDialog = () => { setInterviewForm(false) };
    const [submissionForm, setSubmissionForm] = useState(false);
    const hideSubmissionFormDialog = () => { setSubmissionForm(false) };
    const [submissionList, setSubmissionList] = useState({ singleData: {}, open: false } as { singleData: IBenchConsultant, open: boolean, });
    const hideSubmissionList = () => { setSubmissionList({ singleData: {}, open: false }) };
    const [interviewList, setInterviewList] = useState({ singleData: {}, open: false } as { singleData: IBenchConsultant, open: boolean, });
    const hideInterviewList = () => { setInterviewList({ singleData: {}, open: false }) };

    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Consultant_Bench", "GET", null, `filter=${filters}`, props.toast);
        if (response) {
            const data: Array<IBenchConsultant> = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    }

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptyBenchConsultant });
    };


    const openEdit = (rowDatauser: IBenchConsultant) => {
        rowDatauser.city = {
            city_ID: rowDatauser.city_ID,
            city_Name: rowDatauser.city_Name
        }
        rowDatauser.state = {
            state_ID: rowDatauser.state_ID,
            state_Name: rowDatauser.state_Name
        }
        rowDatauser.marketing_Priority = rowDatauser.priority;
        props.setModal({ open: true, singleData: rowDatauser });
    };

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    {props.permissions.is_Create && <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />}
                    {_roles.includes(24) && <Button label="Submission" icon="pi pi-plus" className="p-button-success mr-2" onClick={() => setSubmissionForm(true)} />}
                    {_roles.includes(24) && <Button label="Interview" icon="pi pi-plus" className="p-button-success mr-2" onClick={() => setInterviewForm(true)} />}
                </div>
            </React.Fragment>
        );
    };

    const rightToolbarTemplate = () => {
        return (
            props.permissions.is_Export ?
                <React.Fragment>
                    <Button label="Export" icon="pi pi-upload" className="p-button-help" onClick={exportCSV} />
                </React.Fragment> : ''
        );
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center mr-2">
            <h5 className="m-0">Bench Consultant</h5>
        </div>
    );

    const consultant_ID = (rowData: IBenchConsultant) => {
        return (_roles.includes(24) ?
            <span onClick={() => setSlist({ singleData: rowData, open: true })}
                className="cursor-pointer text-cyan-700 underline">
                {rowData.consultant_ID}
            </span> : <span >{rowData.consultant_ID} </span>
        );
    };
    const marketing_Status = (rowData: IBenchConsultant) => {
        return (
            <span onClick={() => _roles.includes(24) && setStatus({ singleData: rowData, open: true })}
                className="cursor-pointer text-cyan-700 underline">
                {rowData.marketing_Status}
            </span>
        );
    };
    const confirmation_Date = (rowData: IBenchConsultant) => {
        let date;
        if (rowData.confirmation_Date) date = format(new Date(rowData.confirmation_Date), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };
    const actionBodyTemplate = (rowData: IBenchConsultant) => {
        return (
            <div className="actions">
                {_roles.includes(24) && <Button icon="pi pi-pencil" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => openEdit(rowData)} />}
            </div>
        );
    };
    const numOfSub = (rowData: IBenchConsultant) => {
        return (
            <span onClick={() => setSubmissionList({ singleData: rowData, open: true })}
                className="cursor-pointer text-cyan-700 underline">
                {rowData.numOfSub}
            </span>
        );
    };
    const numOfECI = (rowData: IBenchConsultant) => {
        return (
            <span onClick={() => setInterviewList({ singleData: rowData, open: true })}
                className="cursor-pointer text-cyan-700 underline">
                {rowData.numOfECI}
            </span>

        );
    };

    const DateFormat = loginObj?.date_Format;

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter setFilters={(filters: string | null) => setFilters(filters)} />
                </AccordionTab>
            </Accordion>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
                selectionMode={'checkbox'}
                selection={selectedBenchs}
                onSelectionChange={(e) => {
                    const value = e.value as IBenchConsultant[];
                    setSelectedBenchs(value);
                }}
            >
                {_roles.includes(24) && <Column selectionMode="multiple" />}
                <Column field="consultant_ID" header="ID" body={consultant_ID} sortable />
                <Column field="consultant_Name" header="Consultant Name" sortable />
                <Column field="job_Titles" header="Job Title" />
                <Column field="phone" header="Phone No" />
                <Column field="location" header="Location" />
                <Column field="visa_Name" header="Visa" />
                <Column field="rate" header="Rate" />
                <Column field="f2F" header="F2F" />
                <Column field="recruiter" header="Recruiter" />
                <Column field="branch" header="Branch" />
                <Column field="sales" header="Hold By" />
                <Column field="comment" header="Comments" />
                <Column field="numOfSub" header="Sub" body={numOfSub} sortable />
                <Column field="numOfECI" header="ECI" body={numOfECI} sortable />
                <Column field="priority" header="Priority" sortable />
                <Column field="marketing_Status" header="Status" body={marketing_Status} sortable />
                {/* <Column field="benchDate" header="on Bench" /> */}
                <Column field="benchDate" header="on Bench" style={{minWidth: '100px'}} body={(rowData: any) => safeFormatDate( rowData.benchDate, "dd/MM/yyyy", DateFormat)}/>
                <Column field="confirmation_Date" header="Cnf Date" body={confirmation_Date} />
                <Column field="consultant_Type" header="Consultant Type" />
                {props.permissions.is_Update && <Column body={actionBodyTemplate} />}
            </DataTable>
            <SalesManagerList open={slist.open} hideDialog={hideSlistDialog} toast={props.toast} singleData={slist.singleData} />
            <Status open={status.open} hideDialog={hideStatusDialog} toast={props.toast} singleData={status.singleData} reload={props.reload} setReload={props.setReload} />
            <Interview reload={props.reload} setReload={props.setReload} singleData={{ interview_Status: "ECI Scheduled" }} open={interviewForm} hideDialog={hideInterviewFormDialog} toast={props.toast} />
            <Submission reload={props.reload} setReload={props.setReload} singleData={{ submissionStatus: "Submitted to Prime Vendor" }} open={submissionForm} hideDialog={hideSubmissionFormDialog} toast={props.toast} />
            <BenchSubmissionList open={submissionList.open} singleData={submissionList.singleData} toast={props.toast} hideDialog={hideSubmissionList} />
            <BenchECIList open={interviewList.open} singleData={interviewList.singleData} toast={props.toast} hideDialog={hideInterviewList} />
            {_roles.includes(24) && <Button label="Generate Hotlist" className="mt-2" onClick={() => {
                let selectedID: (number | undefined)[] = selectedBenchs?.map(el => el.consultant_ID) || [];
                setSelectedHotList(selectedID);
                if (selectedID.length === 0) {
                    props.toast.current.show({ severity: 'error', detail: "Select a Consultant Person.", life: 3000 });
                } else {
                    setOpenHotList(true);
                }
            }} />}
            <HotList singleData={selectedHotList} open={openHotList} hideDialog={hideDialog} toast={props.toast} setSelectedBenchs={setSelectedBenchs} />
        </>
    );
}
